export default __webpack_public_path__ + "static/media/ManropeExtraLight.1a3dedb2.woff";